import actions from './actions'
import crudReducers from '../../crud/reducers'

const dataPropName = 'supportTask'

const initState = {
  list: [],
  listLoaded: false,
  loading: false,
  loaded: false,
  updating: false,
  error: false,
  modalActive: false,
  supportTask: {}
}

const reducers = crudReducers(actions, dataPropName, initState)

export default reducers
